import { LegalAgreementCaptivePortal } from './legalAgreementCaptivePortal';
import { LegalAgreementModal } from './legalAgreementModal';

export {
  LegalAgreementCaptivePortal,
  LegalAgreementModal
}